import Date from "../../../data/fieldRenderers/Date";
import Duration from "../../../data/fieldRenderers/Duration";
import ID from "../../../data/fieldRenderers/ID";
import State from "../../../data/fieldRenderers/JobState";
import Tag from "../../../data/fieldRenderers/Tag";
import type { FieldRenderers } from "../../../data/types";
import type { DataType } from "./fields";

const fieldRenderers: FieldRenderers<DataType> = {
  Date,
  Duration,
  ID,
  State,
  Tag,
};

export default fieldRenderers;
